// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GeoRegion from "../entity/GeoRegion.bs.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeGeoregion(json) {
  return DeccoUtils$Catalyst.resolveResult(GeoRegion.t_decode(json), "CommonStateMapper.GeoRegions");
}

function builder(json) {
  return Json_decode.field("geo_regions", (function (param) {
                return Json_decode.list(decodeGeoregion, param);
              }), json);
}

export {
  decodeGeoregion ,
  builder ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
